module.exports = __webpack_public_path__ + "media/images/flags/gb-eng-c15527cb1d4c6696ba3cb88eb8d3ab1c.svg";